import { render } from "./EmployeeUpdatePhoto.vue?vue&type=template&id=4da653a6&scoped=true"
import script from "./EmployeeUpdatePhoto.vue?vue&type=script&lang=js"
export * from "./EmployeeUpdatePhoto.vue?vue&type=script&lang=js"

import "./EmployeeUpdatePhoto.vue?vue&type=style&index=0&id=4da653a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da653a6"]])

export default __exports__